<template>
  <div id="app" :class="{ 'fix-ie': showLoader }">
    <div id="nprogress-container" />
    <ald-loader v-if="showLoader" :text="`${loaderText}...`" />
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AldAutomotive',

  data: () => ({}),

  computed: {
    showLoader() {
      return this.$store.getters['ui/dataUI']('loader');
    },

    loaderText() {
      return (
        this.$store.getters['ui/dataUI']('loaderText') || this.$t('message.generic.loadingData')
      );
    }
  },

  mounted() {
    this.$cookiebot.consentBanner();
    this.setTheme(this.$store.getters['ui/dataUI']('theme'));

    this.$store.watch(
      getters => getters.ui.theme,
      val => {
        this.setTheme(val);
      }
    );

    this.$store.watch(
      getters => getters.error,
      val => {
        if (val) {
          this.$router.push({ name: 'error' }).catch(() => ({}));
        }
      }
    );
  },

  methods: {
    setTheme(theme) {
      this.$el.parentElement.className = `theme-${theme}`;
    },

    goToCookiesPolicy() {
      this.$router.push('/legal/cookies_es-ES');
    }
  }
};
</script>
